import { useProgrammatic } from '@oruga-ui/oruga-next';

import DialogDisplay from '@/components/DialogDisplay.vue';

const {oruga} = useProgrammatic();

type PropsType = {
  props: {
    canCancel?: boolean,
    cancelText?: string,
    confirmText?: string,
    title?: string | null,
    message: string,
    onCancel?: Function | null,
    onConfirm?: Function | null,
  },
};

export default function Dialog(config: PropsType) {

  const {props, ...newConfig} = {...config};

  oruga.notification.open({
    component: DialogDisplay,
    props: {
      ...props,
    },
    indefinite: true,
    position: 'top',
    variant: 'success',
    ...newConfig,
  });
};
